import React from 'react';

const PhoneInput = ({ question, value, onChange, error }) => {
  const handleChange = (e) => {
    const val = e.target.value.replace(/\D/g, ''); // Remove non-digits
    if (val.length <= 10) {
      onChange(val);
    }
  };

  const validatePhone = (phone) => {
    const phoneRegex = /^[6-9]\d{9}$/;
    return phoneRegex.test(phone);
  };

  return (
    <div className="question-input">
      <input
        type="tel"
        value={value || ''}
        onChange={handleChange}
        placeholder={question.placeholder}
        className={`quiz-input ${error ? 'error' : ''}`}
        required={question.required}
      />
      {error && <span className="error-message">{error}</span>}
      {value && !validatePhone(value) && (
        <span className="validation-message">
          {question.patternMessage || 'Please enter a valid phone number'}
        </span>
      )}
    </div>
  );
};

export default PhoneInput;